import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { Profile, Languages } from 'src/app/core/models/profile';
import { EnvironmentService } from '../../core/enviroment/environment.service';
// tslint:disable: max-line-length

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  private uri = this.environmentService.getEnvVar('api_profile');
  public perfil = new Subject<any>();
  update$ = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) { }

  public getPerfil() {
    return this.perfil.asObservable();
  }

  public sendPerfil(param) {
    setTimeout(() => {
      this.perfil.next(param);
    }, 50);
  }

  public findByName(name: string): Observable<Profile> {
    return this.http.get<Profile>(`${this.uri}/profile/${name}?` + Math.random());
  }

  public findLanguages(): Observable<any> {
    return this.http.get<Languages>(`${this.uri}/languages`).pipe(
      map(resp => {
        const languages = resp.languages.map(({description}) => description);
        const proficiencia = resp.proficiencies.map(({description}) => description);
        return { languages, proficiencia };
      })
    );
  }

  public profileEdit(data): Observable<any> {
    return this.http.patch<any>(`${this.uri}/profile/`, data);
  }

  getUpdateProfile(): Observable<boolean> {
    return this.update$.asObservable();
  }

  setUpdateProfile(): void {
    this.update$.next(true);
  }

  getDefaultBiography(company): string {
    return `Olá! Sou corretor de imóveis associada à imobiliária ${company}. Confira abaixo todos os detalhes dos imóveis que busquei e selecionei para você. Estou pronto para esclarecer todas as suas dúvidas e lhe ajudar da melhor maneira possível.`;
  }

}
